import { CardEmptyState, CardFooterAction, ChickletHoverActions, ChickletSecondaryDisplayLabels } from '../constants/BehaviorTypes';
import CompanyCardEmptyState from '../behaviors/company/CompanyCardEmptyState';
import getCompanyChickletHoverActions from '../behaviors/company/getCompanyChickletHoverActions';
import getCompanyChickletSecondaryDisplayLabels from '../behaviors/company/getCompanyChickletSecondaryDisplayLabels';
import useCompanyCardFooterAction from '../behaviors/company/useCompanyCardFooterAction';
export const Company = {
  [CardEmptyState]: () => CompanyCardEmptyState,
  [ChickletHoverActions]: () => getCompanyChickletHoverActions,
  [ChickletSecondaryDisplayLabels]: () => getCompanyChickletSecondaryDisplayLabels,
  [CardFooterAction]: () => useCompanyCardFooterAction
};